var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{class:[
    'recommendation__name',
    {
      'recommendation__name--colors': _vm.colorOptionsLength,
    } ],attrs:{"itemprop":"name","title":_vm.name}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }